import React, { createContext, useState, useMemo, useEffect } from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from '@material-ui/styles'
import { CssBaseline } from '@material-ui/core'
import { getTheme } from '../theme'

export const ThemeModeContext = createContext({
  isDarkMode: false,
  toggleThemeMode: () => { },
})

const LOCAL_STORAGE_KEY = 'sigep:themeMode'

export const ThemeModeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    try {
      const savedMode = localStorage.getItem(LOCAL_STORAGE_KEY)
      if (savedMode) {
        return JSON.parse(savedMode)
      }
    } catch (error) {
      console.error('Erro ao carregar o tema do localStorage', error)
    }

    // Caso não tenha nada no localStorage, podemos checar a preferência do sistema
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return true
    }
    return false
  })

  const toggleThemeMode = () => {
    setIsDarkMode((prevMode) => {
      const newMode = !prevMode
      try {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newMode))
      } catch (error) {
        console.error('Erro ao salvar o tema no localStorage', error)
      }
      return newMode
    })
  }

  const theme = useMemo(() => getTheme(isDarkMode), [isDarkMode])

  // Efeito para sincronizar o atributo dark mode global no body, útil para estilizações globais/SCSS legados
  useEffect(() => {
    if (isDarkMode) {
      document.body.classList.add('dark-mode')
    } else {
      document.body.classList.remove('dark-mode')
    }
  }, [isDarkMode])

  return (
    <ThemeModeContext.Provider value={{ isDarkMode, toggleThemeMode }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeModeContext.Provider>
  )
}

ThemeModeProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
